








import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GTopicSubject',
  computed: {},
  methods: {},
})
export default class GTopicSubject extends mixins(GPageBase) {
  mounted() {}
}
